import { Button } from "@tfg/ui"

type ToggleUserStatusButtonProps = {
  organizationId: string
  user: {
    id: string
    email: string
    name: string
    active: boolean
  }
  openModal: () => void
}

export const ToggleUserStatusButton = ({
  user,
  openModal,
}: ToggleUserStatusButtonProps) => {
  const isActive = user.active

  const buttonText = isActive ? "Deactivate user" : "Activate user"
  const testId = isActive ? "deactivate-user" : "activate-user"

  return (
    <Button
      variant="primary"
      fullWidth={false}
      data-user-email={user.email}
      data-testid={testId}
      onClick={openModal}
    >
      {buttonText}
    </Button>
  )
}
